<template>
  <div class="container-fluid pg_module inst_signup">

    <div class="row top-bar" v-if="institutionMeta">
      <div class="col-12">
        <div class="row header mt-2">
          <div class="col-4"></div>
          <div class="col-4 logo_container">
            <template v-if="otherInstitutionMeta">
              <template v-if="otherInstitutionMeta.logo">
                <img class="logo ace_sec" :src="otherInstitutionMeta.logo" alt="institutionMeta logo">
              </template>
              <template v-else>
                <h3>{{otherInstitutionMeta.title}}</h3>
              </template>
            </template>
            <template v-else>
              <template v-if="institutionMeta.logoUrl">
                <img class="logo ace_sec" :src="logoUrl" alt="institutionMeta logo">
              </template>
              <template v-else>
                <h3>{{institutionMeta.title}}</h3>
              </template>
            </template>
          </div>
          <div class="col-3">
            <div class="d-none" v-if="institutionMeta.fontFamily">
              <font-picker :api-key="apiKey" :active-font="institutionMeta.fontFamily" :options="{name: 'srf'}"></font-picker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row page_content create-section apply-font-srf">
      <div class="content-section" v-if="institutionMeta" :style="{color: institutionMeta.backgroundColor}">
        <div class="inst_form_pg">

          <template v-if="otherInstitutionMeta">
            <div class="row mb-3" v-if="otherInstitutionMeta.customText">
              <div class="col-12 p-3">
                <span v-html="otherInstitutionMeta.customText" ref="customText"></span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="row mb-3" v-if="institutionMeta.customText">
              <div class="col-12 p-3">
                <span v-html="institutionMeta.customText" ref="customText"></span>
              </div>
            </div>
          </template>
          <template v-if="orgId">
            <template v-if="showVerifyEmail">
              <div class="row fld_row">
                <div class="col-12">
                  <div class="text-center">
                    <h3>Verify Email</h3>
                  </div>
                </div>
                <div class="col-12 mt-3">
                  <div class="text-center">
                    <h6>A verification code has been sent to your email</h6>
                    <p>You will use your email to log in to our learning platform.
                      Please enter the verification code sent to your email.
                      If you don’t see the email, please check your spam or bulk mail folders.</p>
                  </div>
                </div>
                <div class="col-12 mt-2">
                  <div class="text-center">
                    <h6>{{eMail}}</h6>
                  </div>
                </div>
              </div>
              <div class="row fld_row">
                <div class="col-12 row">
                  <div class="col-5 fld_label" id="verificationCode">Verification Code <sup>*</sup></div>
                  <div class="col-7">
                    <b-form-input type="text" v-model.trim="verificationCode" :state="verificationCodeState"
                      placeholder="Verification Code" @input="$v.verificationCode.$touch()"
                      aria-describedby="verificationCodeFeedback" style="height: 1.5em !important; width: 40% !important;">
                    </b-form-input>
                    <b-form-invalid-feedback id="verificationCodeFeedback">
                      Verification Code is required
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>
              <div class="row fld_row">
                <div class="col-12 mt-3">
                  <div class="text-center">
                    <b-button size="lg" @click="verifyEmail" aria-label="verify email" class="apply-font-srf" :style="{'background-color': institutionMeta.primaryColor, color: institutionMeta.secondaryColor}">Verify Email</b-button>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="isExistingAccount">
                <div class="row fld_row">
                  <div class="col-12 sec_hd">
                    <span>Login to {{institutionMeta.displayName}} </span>
                  </div>
                </div>
                <div class="row fld_row" style="margin-bottom: 0px;">
                  <div class="col-12" id="validation-message">
                    <div style="color: #ff0000; text-align: center;" v-html="errorMessage"></div>
                  </div>
                </div>
                <div @keydown.enter="login">
                  <div class="row fld_row">
                    <div class="col-12 fld_label" id="userEmail">Email <sup>*</sup></div>
                    <div class="col-12 fld_input">
                      <b-form-input type="email" v-model.email="eMail" :state="eMailState"
                        aria-labelledby="email" placeholder="Email" @input="forceEmailLowerCase($event)"
                        aria-describedby="eMailFeedback" style="width: 91%;">
                      </b-form-input>
                      <b-form-invalid-feedback id="eMailFeedback">
                        This is not a valid email
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="row fld_row">
                    <div class="col-12 fld_label" id="password">Password <sup>*</sup></div>
                    <div class="col-12 fld_input password_input_fld">
                      <b-form-input v-if="showPassword" type="text" v-model.trim="password" :state="passwordState"
                        aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                        aria-describedby="passwordFeedback" style="width: 91%;">
                      </b-form-input>
                      <b-form-input v-else type="password" v-model.trim="password" :state="passwordState"
                        aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                        aria-describedby="passwordFeedback" style="width: 91%;">
                      </b-form-input>
                      <div class="control">
                        <button class="button" @click="toggleShowPassword">
                          <span class="icon is-small is-right">
                            <span class="fas" :class="{ 'fa-eye': showPassword, 'fa-eye-slash': !showPassword }"></span>
                          </span>
                        </button>
                      </div>
                      <b-form-invalid-feedback id="passwordFeedback">
                        Password should be 6 characters
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="row fld_row">
                    <div class="col-12 fld_label">
                      <div class="row">
                        <div class="col-8 lnk_container pt-2">
                          <a href="javascript:void(0)" @click="forgotPassword" :style="getLinkColor">Forgot password</a>
                        </div>
                        <div class="col-4 btn_container" style="padding-left: 1.5rem;">
                          <b-button size="lg" @click="login" class="apply-font-srf">login</b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row fld_row">
                    <div class="col-12 fld_label">
                      <div class="row">
                        <div class="col-12 lnk_container pt-2">
                          <a href="javascript:void(0)" @click="switchToLogin('signup')" v-if="institutionMeta.openId !== '11046899999'">Sign up if you don't have an account</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="isOtherInstitutionAccount">
                <div class="row fld_row">
                  <div class="col-12 sec_hd">
                    <span>Login to {{institutionMeta.title}} </span>
                    <h6 class="hd_sec_msg existing_acc" v-html="otherInstitutionMeta.message"></h6>
                  </div>
                </div>
                <div class="row fld_row" style="margin-bottom: 0px;">
                  <div class="col-12" id="validation-message">
                    <div style="color: #ff0000; text-align: center;" v-html="errorMessage"></div>
                  </div>
                </div>
                <div @keydown.enter="login">
                  <div class="row fld_row">
                    <div class="col-12 fld_label" id="userEmail">Email <sup>*</sup></div>
                    <div class="col-12 fld_input">
                      <b-form-input type="email" v-model.email="eMail" :state="eMailState"
                        aria-labelledby="email" placeholder="Email" @input="forceEmailLowerCase($event)"
                        aria-describedby="eMailFeedback" style="width: 91%;">
                      </b-form-input>
                      <b-form-invalid-feedback id="eMailFeedback">
                        This is not a valid email
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="row fld_row">
                    <div class="col-12 fld_label" id="password">Password <sup>*</sup></div>
                    <div class="col-12 fld_input password_input_fld">
                      <b-form-input v-if="showPassword" type="text" v-model.trim="password" :state="passwordState"
                        aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                        aria-describedby="passwordFeedback" style="width: 91%;">
                      </b-form-input>
                      <b-form-input v-else type="password" v-model.trim="password" :state="passwordState"
                        aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                        aria-describedby="passwordFeedback" style="width: 91%;">
                      </b-form-input>
                      <div class="control">
                        <button class="button" @click="toggleShowPassword">
                          <span class="icon is-small is-right">
                            <span class="fas" :class="{ 'fa-eye': showPassword, 'fa-eye-slash': !showPassword }"></span>
                          </span>
                        </button>
                      </div>
                      <b-form-invalid-feedback id="passwordFeedback">
                        Password should be 6 characters
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="row fld_row">
                    <div class="col-12 fld_label">
                      <div class="row frm_action">
                        <div class="col-8 lnk_container">
                          <a href="javascript:void(0)" @click="forgotPassword">Forgot password</a>
                        </div>
                        <div class="col-4 btn_container" style="padding-left: 1.5rem;">
                          <b-button size="lg" @click="login" class="apply-font-srf">login</b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="institutionMeta.openId !== '11046899999'">
                <div class="row fld_row">
                  <div class="col-12 sec_hd">
                    <span>Sign up to Explore  {{institutionMeta.title}} Programs & Careers </span>
                  </div>
                </div>
                <div class="row fld_row">
                  <div class="col-12 fld_label" id="firstName">First Name <sup>*</sup></div>
                  <div class="col-12 fld_input">
                    <b-form-input type="text" v-model.trim="firstName" :state="firstNameState"
                      aria-labelledby="firstName" placeholder="First Name" @input="$v.firstName.$touch()"
                      aria-describedby="firstNameFeedback" style="width: 91%;">
                    </b-form-input>
                    <b-form-invalid-feedback id="firstNameFeedback">
                      First Name can not left blank
                    </b-form-invalid-feedback>
                  </div>
                </div>
                <div class="row fld_row">
                  <div class="col-12 fld_label" id="lastName">Last Name <sup>*</sup></div>
                  <div class="col-12 fld_input">
                    <b-form-input type="text" v-model.trim="lastName" :state="lastNameState"
                      aria-labelledby="lastName" placeholder="Last Name" @input="$v.lastName.$touch()"
                      aria-describedby="lastNameFeedback" style="width: 91%;">
                    </b-form-input>
                    <b-form-invalid-feedback id="lastNameFeedback">
                      Last Name can not left blank
                    </b-form-invalid-feedback>
                  </div>
                </div>
                <div class="row fld_row">
                  <div class="col-12 fld_label" id="userEmail">Email <sup>*</sup></div>
                  <div class="col-12 fld_input">
                    <b-form-input type="email" v-model.email="eMail" :state="eMailState"
                      aria-labelledby="email" placeholder="Email" @input="forceEmailLowerCase($event)"
                      aria-describedby="eMailFeedback" style="width: 91%;">
                    </b-form-input>
                    <b-form-invalid-feedback id="eMailFeedback">
                      This is not a valid email
                    </b-form-invalid-feedback>
                  </div>
                </div>
                <div class="row fld_row">
                  <div class="col-12 fld_label" id="password">Password <sup>*</sup></div>
                  <div class="col-12 fld_input password_input_fld">
                    <b-form-input v-if="showPassword" type="text" v-model.trim="password" :state="signupPasswordState"
                      aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                      aria-describedby="passwordFeedback" style="width: 91%;">
                    </b-form-input>
                    <b-form-input v-else type="password" v-model.trim="password" :state="signupPasswordState"
                      aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                      aria-describedby="passwordFeedback" style="width: 91%;">
                    </b-form-input>
                    <div class="control">
                      <button class="button" @click="toggleShowPassword">
                        <span class="icon is-small is-right">
                          <span class="fas" :class="{ 'fa-eye': showPassword, 'fa-eye-slash': !showPassword }"></span>
                        </span>
                      </button>
                    </div>
                    <b-form-invalid-feedback id="passwordFeedback">
                      Password should be atleast 8 characters, must contains at least one uppercase letter, one lowercase letter, one number and one special character(@$!%*?&).
                    </b-form-invalid-feedback>
                  </div>
                </div>
                <div class="row fld_row">
                  <div class="col-12 fld_label">By Clicking on Sign Up, you accept to the <a href="https://site.pragyasystems.com/terms-of-use/" target="_blank">terms of use</a> & <a href="https://site.pragyasystems.com/privacy-policy/" target="_blank">privacy policy</a>.</div>
                </div>
                <div class="row fld_row">
                  <div class="col-12 fld_label">
                    <div class="row">
                      <div class="col-7 lnk_container pt-2">
                        <a href="javascript:void(0);" @click="switchToPragyaLogin('login')" v-if="institutionMeta.openId === 'PRAGYA_OPEN_LEARNER'">Login if you have an account</a>
                        <a href="javascript:void(0);" @click="switchToLogin('login')" v-else>Login if you have an account</a>
                     </div>
                      <div class="col-5 btn_container" style="padding-left: 2rem;">
                        <b-button size="lg" @click="createAccount" class="apply-font-srf">sign up</b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row fld_row">
                  <div class="col-12">
                    <div class="text-center">
                      <h4>Self Registration Not Enabled. Please contact {{institutionMeta.displayName}}.</h4>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </template>
          <template v-else>
            <div class="row fld_row">
              <div class="col-12">
                <div class="text-center">
                  <h4>Self Registration Link is not valid. Please contact {{institutionMeta.displayName}}.</h4>
                </div>
              </div>
            </div>
          </template>

        </div>
      </div>
    </div>
    <div v-if="institutionMeta">
      <b-modal v-model="showForgotPasswordModal" title="Forgot Password" :header-bg-variant="'light'" :header-text-variant="'dark'" :footer-bg-variant="'light'" no-close-on-backdrop no-close-on-esc centered class="apply-font-srf forgot_password_modal">
        <div slot="modal-header" class="header-section w-100">
          <div class="row">
            <div class="col-10 popup_head_txt">
              <span :style="{color: institutionMeta.backgroundColor}">Forgot Password</span>
            </div>
            <div class="col-2 btn_container">
              <button class="btn_close" aria-label="close" @click="showForgotPasswordModal = false" :style="{color: institutionMeta.primaryColor}">
                <span class="ic-close"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="inst_form_pg text-center" @keydown.enter="resetPassword">
          <template v-if="resetPasswordMessage">
            <span style="color: Red;">{{resetPasswordMessage}}</span>
          </template>
          <template v-else>
            <div class="row fld_row">
              <div class="col-12 fld_label">
                <div>User Email</div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="email" v-model.email="resetPasswordEmail" :state="resetPasswordEmailState"
                  aria-labelledby="reset email" placeholder="Email" @blur.native="$v.resetPasswordEmail.$touch()"
                  aria-describedby="resetPasswordEmailFeedback" style="width: 96%;" :style="{color: institutionMeta.backgroundColor}">
                </b-form-input>
                <b-form-invalid-feedback id="resetPasswordEmailFeedback">
                  Please enter a proper email address.
                </b-form-invalid-feedback>
              </div>
            </div>
          </template>
        </div>
        <div slot="modal-footer" class="w-100">
          <div class="btn_container">
            <template v-if="resetPasswordMessage">
              <b-button variant="primary" size="sm" class="float-right apply-font-srf" @click="showForgotPasswordModal = false">ok</b-button>
            </template>
            <template v-else>
              <b-button variant="primary" size="sm" class="float-right ml-3 apply-font-srf" @click="resetPassword">get new password</b-button>
              <b-button variant="primary" size="sm" class="float-right apply-font-srf" @click="showForgotPasswordModal = false">cancel</b-button>
            </template>
          </div>
        </div>
      </b-modal>
    </div>

    <div>
        <b-modal v-model="showSsoModel" title="Confirm Email address" no-close-on-backdrop no-close-on-esc centered>
            <div class="text-center">
                    <div class="float-left mr-3">
                        <div class="fld-label">You already have an account with this email via <b><i> {{ssoInstitutionName}} </i></b></div>
                        <div class="fld-label">Are you sure you want to use the same email to access <b><i> {{institutionMeta.title}} </i></b>?</div>
                    </div>
            </div>
            <div slot="modal-footer" class="w-100">
                    <b-button variant="primary" size="sm" class="float-right ml-3" @click="closeSSOModel">No</b-button>
                    <b-button variant="primary" size="sm" class="float-right ml-3" @click="signupWithEmail">Yes</b-button>
            </div>
        </b-modal>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue'
  import _ from 'lodash'
  import { mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import FontPicker from 'font-picker-vue'
  import {required, email, minLength} from 'vuelidate/lib/validators'
  Vue.use(Vuelidate)
  import { setItem } from '../../../storage'

  export default {
    name: 'learnerSignup',
    components: {
      'font-picker': FontPicker
    },
    data: () => {
      return {
        orgId: null,
        eMail: '',
        firstName: '',
        lastName: '',
        password: '',
        showPassword: false,
        verificationCode: '',
        showVerifyEmail: false,
        isExistingAccount: false,
        roles: {role: 'Student'},
        userProfile: {courses: [], areaOfInterest: [], experience: '', bio: ''},
        institutionMeta: null,
        errorMessage: '',
        showForgotPasswordModal: false,
        showSsoModel: false,
        forceUseSSOEmail: false,
        ssoInstitutionPath: '',
        ssoInstitutionName: '',
        resetPasswordEmail: '',
        resetPasswordMessage: null,
        otherInstitutionMeta: null,
        isOtherInstitutionAccount: false,
        apiKey: 'AIzaSyAa3D-xZhJGxFRI2cxDX6iInTwA4hKy3pc'
      }
    },
    validations: {
      eMail: {
        required,
        email
      },
      firstName: {
        required
      },
      lastName: {
        required
      },
      password: {
        required,
        minLength: minLength(6)
      },
      verificationCode: {
        required
      },
      resetPasswordEmail: {
        required,
        email
      }
    },
    created () {
      this.resetData()
      this.orgId = this.getQueryParamByName('orgId')
      this.eMail = this.getQueryParamByName('email')
      this.isExistingAccount = this.getQueryParamByName('isExistingAccount')

     let utm_medium = this.getQueryParamByName('utm_medium')
      localStorage.setItem('utm_medium', utm_medium)
      let utm_source = this.getQueryParamByName('utm_source')
      localStorage.setItem('utm_source', utm_source)
      let utm_campaign = this.getQueryParamByName('utm_campaign')
      localStorage.setItem('utm_campaign', utm_campaign)
      let utm_content = this.getQueryParamByName('utm_content')
      localStorage.setItem('utm_content', utm_content)
      let utm_term = this.getQueryParamByName('utm_term')
      localStorage.setItem('utm_term', utm_term)

    },
    async mounted () {
      this.institutionMeta = await this.loadInstitutionMetaInfoForSelfRegistration(this.orgId)
      let root = document.documentElement;
      root.style.setProperty("--TU__BaseTxtClr", this.institutionMeta.backgroundColor); // Other Text Color
      root.style.setProperty("--TU__BtnClrPri", this.institutionMeta.primaryColor); // Button Color
      root.style.setProperty("--TU__BtnTxtClrPri", this.institutionMeta.secondaryColor); // Button Text Color
      root.style.setProperty("--TU__BtnHoverClrPri", this.institutionMeta.buttonHoverColor); //Button Hover Color
      root.style.setProperty("--TU__BtnTxtHoverClrPri", this.institutionMeta.secondaryColor); // Button Text Color
      root.style.setProperty("--TU__BtnClrSec", this.institutionMeta.primaryColor); // Button Color
      root.style.setProperty("--TU__BtnHoverClrSec", this.institutionMeta.buttonHoverColor);  //Button Hover Color
      root.style.setProperty("--TU__LnkClrPri", this.institutionMeta.linkColor); // Link Color
      root.style.setProperty("--TU__LnkHoverClrPri", this.institutionMeta.linkHoverColor); // Link Hover Color
      root.style.setProperty("--TU__LnkClrSec", this.institutionMeta.backgroundColor); // Other Text Color
      root.style.setProperty("--TU__LnkHoverClrSec", this.institutionMeta.backgroundColor); // Other Text Color
      this.loadLogDashboardActivity({action: 'learnerSignup', page: 'learnerSignup', link: '', 'entityUuid':'', 'programCipCode':'', 'careerSocCode':'', 'programCode':'', 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title})

      if (this.eMail) {
        this.showVerifyEmail = true
      }
      setTimeout(() => {
        this.updateCustomTextFontFamily()
      }, 1000)
    },
    computed: {
      eMailState () {
        return (this.eMail.length === 0) ? null : !this.$v.eMail.$error
      },
      firstNameState () {
        return (this.firstName.length === 0) ? null : !this.$v.firstName.$error
      },
      lastNameState () {
        return (this.lastName.length === 0) ? null : !this.$v.lastName.$error
      },
      passwordState () {
        return (this.password.length === 0) ? null : !this.$v.password.$error
      },
      signupPasswordState () {
        var basicValidation = (this.password.length === 0) ? null : !this.$v.password.$error
        if(basicValidation) {
          var basicValidation = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(this.password)
        }
        return basicValidation
      },
      verificationCodeState () {
        return (this.verificationCode.length === 0) ? null : !this.$v.verificationCode.$error
      },
      resetPasswordEmailState () {
        return (this.resetPasswordEmail.length === 0) ? null : !this.$v.resetPasswordEmail.$error
      },
      enableCreateAccount () {
        return (this.firstNameState && this.lastNameState && this.eMailState && this.passwordState && this.password.length >= 6)
      },
      enableLogin () {
        return (this.eMailState && this.passwordState && this.password.length >= 6)
      },
      logoUrl () {
        if (this.institutionMeta && this.institutionMeta.logoUrl) {
          return this.institutionMeta.logoUrl
        }
        return null
      },
      getLinkColor () {
        let color = '#157099'
        if (this.institutionMeta && this.institutionMeta.primaryColor) {
          color = this.institutionMeta.primaryColor
        }
        return {'color': color}
      }
    },
    methods: {
      ...mapActions([
        'loadLearnerSelfRegistration',
        'loadVerifySelfRegistration',
        'loadInstitutionMetaInfoForSelfRegistration',
        'loadResetPassword',
        'loadUserLogin',
        'loadLogDashboardActivity'
      ]),
      showLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.hide()
        }
      },
      toggleShowPassword () {
        this.showPassword = !this.showPassword;
      },
      getQueryParamByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&')
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(decodeURIComponent(url))
        if (!results || !results[2]) return ''
        return results[2].replace(/\+/g, ' ')
      },
      forceEmailLowerCase (e) {
        e = e.trim().toLowerCase()
        this.$set(this.$data, 'eMail', e)
        this.$v.eMail.$touch()
      },
      resetData () {
        this.orgId = ''
        this.resetLoginSignupData()
        this.isExistingAccount = false
        this.isOtherInstitutionAccount = false
      },
      closeSSOModel () {
          this.showSsoModel = false
      },
      signupWithEmail () {
        this.forceUseSSOEmail = true
        this.createAccount()
      },
      createAccount () {
        this.$v.eMail.$touch()
        this.$v.firstName.$touch()
        this.$v.lastName.$touch()
        this.$v.password.$touch()
        if (this.enableCreateAccount) {
          this.showLoader()
          let userObj = {
            eMail: this.eMail,
            firstName: this.firstName,
            lastName: this.lastName,
            password: this.password,
            userProfile: this.userProfile,
            loginUsingOtherInstitutionAccount: false,
            sendSelfRegistrationVerificationEmail: true,
            ssoEnabled: this.forceUseSSOEmail
          }
          this.loadLearnerSelfRegistration({orgId: this.orgId, user: userObj}).then(res => {
            if (res) {
              if (res === 'duplicate_email_value') {
                this.hideLoader()
                this.$notify({
                  group: 'notify',
                  type: 'error',
                  title: '',
                  text: 'Please try again. This email "' + this.eMail + '" is already taken.'
                })
              } else if (res.ssoEnabled) {
                this.hideLoader()
                this.showSsoModel = true
                this.ssoInstitutionName = res.ssoInstitutionName
                this.ssoInstitutionPath = res.ssoInstitutionPath

              } else {
                this.hideLoader()
                let otherInstitutionAccount = res.otherInstitutionAccount
                if (otherInstitutionAccount) {
                  this.eMail = ''
                  this.password = ''
                  this.otherInstitutionMeta = res
                  this.isOtherInstitutionAccount = otherInstitutionAccount
                } else {
                  this.hideLoader()
                  this.showVerifyEmail = true
                  let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
                  this.loadLogDashboardActivity({action: 'verifyEmailSent', page: 'learnerSignup', link: '', 'entityUuid':'', 'programCipCode':'', 'careerSocCode':'', 'programCode':'', 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title,preUser})

                }
              }
            } else {
              this.hideLoader()
              this.$notify({
                group: 'notify',
                type: 'error',
                title: '',
                text: 'Please try again. Note that this email "' + this.eMail + '" might already be taken.'
              })
            }
          })
        }
      },
      async verifyEmail () {
        this.$v.verificationCode.$touch()
        if (this.verificationCodeState && this.verificationCode) {
          let userObj = {
            eMail: this.eMail,
            institutionId: this.orgId,
            verificationCode: this.verificationCode
          }
          let response = await this.loadVerifySelfRegistration(userObj)
          let status = response.status
          let data = response.data
          if (status === 200) {
            if (data === 'invalid_verification_code') {
              this.$notify({
                group: 'notify',
                type: 'error',
                title: '',
                text: 'Your verification code is incorrect or expired.'
              })
            } else {
              this.$parent.isLearnerSignUp = false
              let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
              this.loadLogDashboardActivity({action: 'eMailVerified', page: 'learnerSignup', link: '', 'entityUuid':'', 'programCipCode':'', 'careerSocCode':'', 'programCode':'', 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title, preUser})

              this.loadLogDashboardActivity({action: 'signup', page: 'learnerSignup', link: '', 'entityUuid':'', 'programCipCode':'', 'careerSocCode':'', 'programCode':'', 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title,preUser})
              if (!this.validateTnC(data)) {
                return this.$router.push({name: 'termsAndConditions', params: {userObj: data}})
              } else {
                return this.$router.push({name: 'dashboard'})
              }
            }
          }
        }
      },
      resetLoginSignupData () {
        this.eMail = ''
        this.firstName = ''
        this.lastName = ''
        this.password = ''
        this.errorMessage = ''
        this.verificationCode = ''
        this.otherInstitutionMeta = null
      },
      switchToLogin (action) {
        this.resetLoginSignupData()
        if (action === 'login') {
          let path = this.institutionMeta.path
          let ssoUrl = this.institutionMeta.ssoUrl
          if (path && ssoUrl) {
            window.open(window.location.origin + '/sso/' + path, '_self')
          } else {
            this.isExistingAccount = true
          }
        } else {
          this.isExistingAccount = false
        }
      },
      switchToPragyaLogin (action) {
        this.resetLoginSignupData()
        window.open(window.location.origin + '/mobile/vue/#/login', '_self')
        window.location.reload();
      },

      login () {
        this.$v.eMail.$touch()
        this.$v.password.$touch()
        if (this.enableLogin) {
          this.showLoader()
          this.errorMessage = ''
          if (this.isOtherInstitutionAccount) {
            let userObj = {
              eMail: this.eMail,
              firstName: this.firstName,
              lastName: this.lastName,
              password: this.password,
              userProfile: this.userProfile,
              loginUsingOtherInstitutionAccount: true,
              sendSelfRegistrationVerificationEmail: false
            }
            this.loadLearnerSelfRegistration({orgId: this.orgId, user: userObj}).then(res => {
              let data = res.data
              let status = res.status
              if (status === 200) {
                this.$parent.isLearnerSignUp = false
                if (!this.validateTnC(data)) {
                  this.hideLoader()
                  return this.$router.push({name: 'termsAndConditions', params: {userObj: data}})
                } else {
                  this.hideLoader()
                  return this.$router.push({name: 'dashboard'})
                }
              } else {
                this.hideLoader()
                switch (status) {
                  case 401:
                    this.errorMessage = data
                    break
                  case 400:
                    this.errorMessage = 'Please enter all required fields'
                    break
                  case 503:
                    this.errorMessage = 'Server temporarily unavailable'
                    break
                  default:
                    this.errorMessage = 'Unexpected error code: ' + status
                    break
                }
              }
              if (this.errorMessage.length > 0) {
                //$('#validation-message').fadeIn('fast').delay(3000).fadeOut('slow')
              }
            })
          } else {
            this.loadUserLogin({eMail: this.eMail, password: this.password, institutionId:this.institutionMeta.openId !== '11046899999'?this.institutionMeta.institutionId:undefined}).then(res => {
              let status = res.status
              let userObj = res.data
              if (status === 200) {
                this.hideLoader()
                let role = userObj.roles[0].role
                if (userObj.institutionId !== this.institutionMeta.institutionId && this.institutionMeta.openId !== '11046899999') {
                  this.errorMessage = '<b>' + this.eMail + '</b> does not exist in <b>' + this.institutionMeta.title + '</b>. Please contact your administrator.'
                }
                if (role !== this.roles.role) {
                  this.errorMessage = 'You don\'t have a <b>Learner account</b> in <b>' + this.institutionMeta.title + '</b>. Please contact your administrator.'
                }
                if (!this.errorMessage || (this.errorMessage.length === 0)) {
                  this.$parent.isLearnerSignUp = false
                  let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
                  this.loadLogDashboardActivity({action: 'signin', page: 'learnerSignup', link: '', 'entityUuid':'', 'programCipCode':'', 'careerSocCode':'', 'programCode':'', 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title,preUser})
                  if (!userObj.tnCAccepted) {
                    return this.$router.push({name: 'termsAndConditions', params: {userObj: userObj}})
                  }
                  return this.$router.push({name: 'dashboard'})
                }
              } else {
                let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
                this.loadLogDashboardActivity({action: 'signinFail', page: 'learnerSignup', link: '', 'entityUuid':'', 'programCipCode':'', 'careerSocCode':'', 'programCode':'', 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institutionMeta.title,preUser})

                this.hideLoader()
                switch (status) {
                  case 503:
                    this.errorMessage = 'Server temporarily unavailable'
                    break
                  case 401:
                    this.errorMessage = 'Invalid email or password'
                    break
                  case 400:
                    this.errorMessage = 'Please enter all required fields'
                    break
                  default:
                    this.errorMessage = 'Unexpected error code: ' + status
                    break
                }
              }
              if (this.errorMessage.length > 0) {
                $('#validation-message').fadeIn('fast').delay(3000).fadeOut('slow')
              }
            })
          }
        }
      },
      validateTnC (userObj) {
        let permission = userObj.permission
        if (!permission.institutionPermission.create && !userObj.tnCAccepted) {
          return false
        }
        return true
      },
      forgotPassword () {
        this.resetPasswordEmail = ''
        this.resetPasswordMessage = null
        this.showForgotPasswordModal = true
        this.$v.resetPasswordEmail.$touch()
      },
      resetPassword () {
        this.$v.resetPasswordEmail.$touch()
        if (this.resetPasswordEmailState) {
          this.loadResetPassword(this.resetPasswordEmail).then(res => {
            let status = res.status
            switch (status) {
              case 401:
                this.resetPasswordMessage = 'This email "' + this.resetPasswordEmail + '" does not exist.'
                break
              case 500:
                this.resetPasswordMessage = 'Error in service call.'
                break
              default:
                this.resetPasswordMessage = 'Please check your registered email for password reset instructions.'
                break
            }
          })
        }
      },
      updateCustomTextFontFamily () {
        if (this.institutionMeta) {
          let parentElem = this.$refs['customText']
          let elems = $(parentElem).find('*')
          _.forEach(elems, (elem) => {
            if ($(elem).css('font-family') !== null) {
              if (this.institutionMeta.fontFamily) {
                $(elem).css('font-family', 'inherit')
              }
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
  .top-bar {
    height: 50px;
    padding-top: 0;
    background: #f5f5f5;
  }
  .content-section {
    float: left;
    width: 100%;
    margin-top: 25px;
    background: #f5f5f5;
    border: 1px solid #e3e3e3;
    padding: 20px;
    border-radius: 0;
  }
  .sec_hd {
    text-align: center;
    font-size: 17px;
    font-weight: 600;
    border-bottom: none;
  }
  .fld_row {
    margin-bottom: 15px;
  }
  .fld_label {
    text-align: left;
    padding-bottom: 5px;
    margin: auto;
    max-width: 450px;
  }
  .create-section .content-section sup {
    color: red;
    font-size: 17px;
    top: -2px;
    left: 2px;
  }
  .popup_head_txt {
    font-size: 1.1rem;
    width: 75%;
    color: #323232;
  }
</style>



// WEBPACK FOOTER //
// src/app/login/components/LearnerSignup.vue